import { temAcesso } from '@/shared/auth/temAcesso'

const Pagamentos = () => import('./Pagamentos.vue')
const Pagamento = () => import('./Pagamento.vue')
const PagamentoAssociarComprometimentos = () =>
    import('./PagamentoAssociarComprometimentos.vue')
const Solicitacoes = () => import('./../../comum/solicitacoes/Solicitacoes.vue')

export default {
    path: 'pagamentos',
    name: 'Contratos_Pagamentos',
    component: Pagamentos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONT-PAG-00')) {
            next()
        }
    },
    children: [
        {
            path: 'solicitacoes',
            name: 'Contratos_Pagamentos_Solicitacoes',
            component: Solicitacoes,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-PAG-05')) {
                    next()
                }
            }
        },
        {
            path: ':pagamentoId',
            name: 'Contratos_Pagamentos_Detalhar',
            component: Pagamento,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONT-PAG-02')) {
                    next()
                }
            },
            children: [
                {
                    path: 'associarservicos',
                    name: 'Contratos_Pagamentos_AssociarComprometimentos',
                    component: PagamentoAssociarComprometimentos,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('CONT-PAG-04')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
